import { z } from "zod";
import { VALIDATION_MESSAGES_CARD, allowedSpecialCharsRegex } from "constants/validations";

// Last Name Schema
export const lastNameSchema = z
    .string()
    .min(1, { message: VALIDATION_MESSAGES_CARD.FIELD_REQUIRED })
    .max(29, { message: "Maximum 29 characters" })
    .regex(allowedSpecialCharsRegex, { message: "Contains invalid characters" });

export const optionalLastNameSchema = z.union([z.literal(""), lastNameSchema]).optional();
